<template>
    <div class="authorCenter">
        <Header></Header>
        <div class="authorBox flexible authorBox-big">
            <sidebar></sidebar>
            <div class="writewrap flex">
                <div class="right author-right">
                    <div class="chapter-title flexible aItem-center jc-between">
                        <div class="page-title font-MT ">
                            <!-- <img class="fh-img" src="@/assets/ic_fh.png" alt="" @click="goBack()"> -->
                            <span class="f22 page-name text-333 fwb-600">个人信息</span>
                        </div>
                    </div>
                    <!-- :rules="rules"  -->
                    <el-form ref="form" class="create-form contract-form" :model="form">
                        <el-form-item label="用户ID">
                            <el-input style="width: 390px;" readonly v-model="form.id" placeholder="请输入您的Id"></el-input>
                        </el-form-item>
                        <el-form-item label="姓名" prop="name">
                            <el-input style="width: 390px;" :disabled="!allowEditForm" v-model="form.name"
                                placeholder="请输入您的姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="笔名(签约合同上会显示，请按真实情况填写)" prop="userName">
                            <el-input style="width: 390px;" :disabled="!allowEditForm" v-model="form.userName"
                                placeholder="请输入您的昵称">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="手机号" prop="mobile">
                            <el-input style="width: 390px;" disabled v-model="form.mobile" placeholder="请输入您的手机号">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="身份证号" prop="idNo">
                            <el-input :disabled="!allowEditForm" v-model="form.idNo" placeholder="请输入您的身份证号"></el-input>
                        </el-form-item>
                        <el-form-item label="邮箱" prop="email">
                            <el-input style="width: 660px;" :disabled="!allowEditForm" v-model="form.email"
                                placeholder="请输入您的邮箱"></el-input>
                            <div class="sms-btn" v-if="isEmailChange == 1" @click="sendEmail()"> 发送验证码</div>
                        </el-form-item>
                        <el-form-item label="邮箱验证码" prop="emailCode" v-if="isEmailChange == 1">
                            <el-input style="width: 660px;" :disabled="!allowEditForm" v-model="form.emailCode"
                                placeholder="请输入您的邮箱验证码"></el-input>
                        </el-form-item>
                        <el-form-item label="地址" prop="address">
                            <el-input :disabled="!allowEditForm" v-model="form.address" placeholder="请输入您的地址">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="开户行信息" prop="bank">
                            <!--                <div class="f12 text-danger">为了您能收到付款，请详细填写。例如：招商银行 XX省XX市XX县XX支行。仅限于中国大陆银行，要具体到支行，否则无法汇款，不予结算！</div>-->
                            <div class="flexible align-center">
                                <div class="bank-input flex flexible align-center">
                                    <span v-if="form.bank" class="flex ml0">{{form.bank}}</span>
                                    <span v-else class="text-muted ml0 f12 flex">请选择您的开户信息</span>
                                    <i class="el-icon-arrow-down mr20 mt15"></i>
                                </div>
                                <el-button v-if="form.bank" class="bank-btn mt0 ml20" type="primary" @click="openbankInfo(1)">重 置</el-button>

                            </div>
                            <!--                <el-input v-model="form.bank" placeholder="请输入您的开户行支行名称">-->
                            <!--                </el-input>-->
                        </el-form-item>

                        <el-form-item prop="account" label="银行卡号">
                            <el-input :disabled="!allowEditForm" v-model="form.account" placeholder="请输入您的银行卡号">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="身份证照片正反面" prop="idFrontImg">
                            <div class="flexible sfz-tips">
                                <div class="avatar-uploader">
                                    <div class="el-upload el-upload--text">
                                        <img class="jia-btn" v-if="!form.idFrontImg" src="@/assets/author/img_add.png">
                                        <img class="sfz-img" v-if="form.idFrontImg" :src="form.idFrontImg">
                                    </div>
                                    <input :disabled="!allowEditForm" type="file" name="file" @change="uploadFun1"
                                        class="el-upload-input"
                                        accept="image/gif,image/jpeg,image/jpg,image/png,image/svg">
                                </div>
                                <div class="avatar-uploader">
                                    <div class="el-upload el-upload--text">
                                        <img class="jia-btn" v-if="!form.idBackImg" src="@/assets/author/img_add.png">
                                        <img class="sfz-img" v-if="form.idBackImg" :src="form.idBackImg">
                                    </div>
                                    <input :disabled="!allowEditForm" type="file" name="file" @change="uploadFun2"
                                        class="el-upload-input"
                                        accept="image/gif,image/jpeg,image/jpg,image/png,image/svg">
                                </div>
                                <div class="tip-text f14">
                                    示例图
                                    <div class="tip-imgs ">
                                        <div class=" flexible aItem-center jc-between">
                                            <img src="@/assets/author/img_sfz1.png">
                                            <img src="@/assets/author/img_sfz2.png">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item label="手持身份证照片正反面" prop="idHandFrontImg">
                            <div class="flexible sfz-tips">
                                <div class="avatar-uploader">
                                    <div class="el-upload el-upload--text">
                                        <img class="jia-btn" v-if="!form.idHandFrontImg"
                                            src="@/assets/author/img_add.png">
                                        <img class="sfz-img" v-if="form.idHandFrontImg" :src="form.idHandFrontImg">
                                    </div>
                                    <input :disabled="!allowEditForm" type="file" name="file" @change="uploadFun3"
                                        class="el-upload-input"
                                        accept="image/gif,image/jpeg,image/jpg,image/png,image/svg">
                                </div>
                                <div class="avatar-uploader">
                                    <div class="el-upload el-upload--text">
                                        <img class="jia-btn" v-if="!form.idHandBackImg"
                                            src="@/assets/author/img_add.png">
                                        <img class="sfz-img" v-if="form.idHandBackImg" :src="form.idHandBackImg">
                                    </div>
                                    <input :disabled="!allowEditForm" type="file" name="file" @change="uploadFun4"
                                        class="el-upload-input"
                                        accept="image/gif,image/jpeg,image/jpg,image/png,image/svg">
                                </div>
                                <div class="tip-text f14 " style="left:215px">
                                    示例图
                                    <div class="tip-imgs ">
                                        <div class=" flexible aItem-center jc-between">
                                            <img src="@/assets/author/img_sfz3.png">
                                            <img src="@/assets/author/img_sfz4.png">
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </el-form-item>
                        <!-- <el-form-item style="text-align: center;">
                            <el-button class="f16 creat-btn" @click="saveInfoFun('form')">确定</el-button>
                        </el-form-item> -->
                    </el-form>
                </div>
            </div>
        </div>
        <!--开户行信息-->
        <el-dialog
                width="675px"
                :append-to-body="true"
                :lock-scroll="true"
                :center="true"
                class="bank-dialog"
                :visible.sync="bankVisible"
        >
            <!-- 是否充值-->
            <div class="bank-reset flexible" v-if="bankVisibleType==1">
                <i class="el-icon-warning"></i>
                <div class="ml0">
                    <div class="bank-reset-title">确定重置银行信息吗？</div>
                    <div class="bank-reset-con">您好，银行信息重置成功后，工作人员在打款时将按照新的银行信息进行操作！如您在重置银行信息之前已经提交提现申请，工作人员将按照您重置之前的银行信息进行操作！</div>
                    <div class="flexible jc-between-end">
                        <el-button class="bank-btn reset-cancel-btn" @click="cancel()">取 消</el-button>
                        <el-button class="bank-btn reset-btn" @click="openbankInfo(2)">确 定</el-button>
                    </div>
                </div>

            </div>

            <!--录入信息-->

            <div v-if="bankVisibleType==2" slot="title" class="dialog-header" style="border-bottom: 1px solid #F3F3F3;">
                开户行信息
            </div>

            <el-form v-if="bankVisibleType==2" class="bankForm" ref="bankForm" :model="bankForm" :rules="bankFormRules">
                <el-form-item label="选择银行:" prop="bank" class="mt24">
                    <el-select placeholder="请选择您的开户银行" v-model="bankForm.bank" style="width: 100%">
                        <el-option v-for="i in bankList" :value="i.text" :label="i.text">{{i.text}}</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="银行卡号:" prop="account" class="mt24" >
                    <el-input placeholder="请输入您的银行卡号" v-model="bankForm.account"></el-input>
                </el-form-item>
                <div class="flexible">
                    <el-form-item label="选择省、市:" prop="provice">
                        <el-select placeholder="请选择" v-model="bankForm.provice" @change="provincekChange">
                            <el-option v-for="i in provinceList" :value="i.code" :label="i.text">{{i.text}}</el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label=" " class="ml24 cityInput" prop="city">
                        <el-select placeholder="请选择" v-model="bankForm.city">
                            <el-option v-for="i in cityList" :value="i.text" :label="i.text">{{i.text}}</el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <el-form-item label="支行名称:" prop="name">
                    <el-input placeholder="请输入您开户行的支行名称" type="textarea" v-model="bankForm.name"></el-input>
                </el-form-item>
                <el-form-item class="flexible jc-center">
                    <el-button class="bank-btn" @click="cancel()">取 消</el-button>
                    <el-button class="bank-btn" type="warning" @click="saveShelf()">确 定</el-button>
                </el-form-item>
            </el-form>


        </el-dialog>
    </div>
</template>

<script>
    import {
        writerInfoApi,
        writerEditApi,
        emailCheckApi,
        writerImgApi,
        modifybankinfo,
        payloggetBank,
        paylogprovince
    } from 'apiurl/author';
    // import {
    //     isAccount
    // } from "utils/core/kernel";
    // import {
    //     fileTransferBase64
    // } from '@/utils/index'
    import baseURL from "@/api/env.js";
    import index from '@/mixins/index';
    import {
        getToken
    } from "utils/storage";
    import {
        hideLoading,
        showLoading
    } from "@/utils/load";
    export default {
        data() {
            var emailRules = (rule, value, callback) => {
                if (this.form.email != this.oldEmail) {
                    this.isEmailChange = 1;
                } else {
                    this.isEmailChange = 2;
                }
                if (!this.form.email) {
                    callback(new Error("请输入正确的邮箱"));
                } else {
                    callback();
                }
            };
            var emailCodeRules = (rule, value, callback) => {
                if (this.isEmailChange = 2) {
                    callback();
                } else if (!this.form.email) {
                    callback(new Error("请输入正确的邮箱"));
                } else {
                    callback();
                }
            };
            var imgRules = (rule, value, callback) => {
                if (!this.form.idFrontImg || !this.form.idBackImg) {
                    callback(new Error("请选择身份证照片正反面"));
                } else {
                    callback();
                }
            };
            var handimgRules = (rule, value, callback) => {
                if (!this.form.idHandFrontImg || !this.form.idHandBackImg) {
                    callback(new Error("请选择手持身份证照片正反面"));
                } else {
                    callback();
                }
            };

            return {
                token: getToken() || null,
                userId: '',
                form: {
                    id: "",
                    name: '',
                    userName: '',
                    mobile: '',
                    idNo: '',
                    email: '',
                    emailCode: '',
                    address: '',
                    bank: '',
                    account: '',
                    idFrontImg: '',
                    idFrontImgPath: '',
                    idBackImg: '',
                    idBackImgPath: '',
                    idHandFrontImg: '',
                    idHandFrontImgPath: '',
                    idHandBackImg: '',
                    idHandBackImgPath: '',
                },
                backupsform: null,
                rules: {
                    name: [{
                        required: true,
                        message: "请输入您的姓名",
                        trigger: "blur"
                    }],
                    userName: [{
                        required: true,
                        message: "请输入您的笔名",
                        trigger: "blur"
                    }],
                    mobile: [{
                        required: true,
                        message: "请输入您的手机号",
                        trigger: "blur"
                    }],
                    idNo: [{
                        required: true,
                        message: "请输入您的身份证号",
                        trigger: "blur"
                    }],
                    email: [{
                        required: true,
                        validator: emailRules,
                        trigger: "change"
                    }],
                    emailCode: [{
                        required: true,
                        validator: emailCodeRules,
                        trigger: "blur"
                    }],
                    address: [{
                        required: true,
                        message: "请输入您的地址",
                        trigger: "blur"
                    }],
                    bank: [{
                        required: true,
                        message: "请输入您的开户行支行名称",
                        trigger: "blur"
                    }],
                    account: [{
                        required: true,
                        message: "请输入您的银行卡号",
                        trigger: "blur"
                    }],
                    idFrontImg: [{
                        required: true,
                        validator: imgRules,
                        trigger: "blur"
                    }],
                    idHandFrontImg: [{
                        required: true,
                        validator: handimgRules,
                        trigger: "blur"
                    }],
                },
                allowEditForm: false,
                uploadIndex: "",
                oldEmail: "", //旧邮箱
                isEmailChange: 2, //邮箱是否改变 1改变，2没改变
                /*开户行*/
                bankVisible: false,
                bankVisibleType: 1,//1=>重置，2=>填信息
                bankList:[],
                provinceList:[],
                cityList:[],

                bankForm:{
                    bank: '',
                    provice:'',
                    provinceDesc:'',
                    city:'',
                    name:'',
                    account:''
                },
                bankFormRules:{
                    bank: [{
                        required: true,
                        message: "请选择你的开户银行",
                        trigger: ["blur","change"]
                    }],
                    provice: [{
                        required: true,
                        message: "请选择你所属省",
                        trigger: ["blur","change"]
                    }],
                    city: [{
                        required: true,
                        message: "请选择你所属市",
                        trigger: ["blur","change"]
                    }],
                    name: [{
                        required: true,
                        message: "请输入支行名称",
                        trigger: ["blur","change"]
                    }],
                    account: [{
                        required: true,
                        message: "请输入银行卡号",
                        trigger: ["blur","change"]
                    }],
                }
                // isChange: 2, // 1改变，2没改变
            }
        },
        watch: {},
        created() {
            this.getNormalInfoFun()
        },
        mixins: [index],
        methods: {
            async getNormalInfoFun() {
                let res = await writerInfoApi()
                if (res.success) {
                    let info = res.data
                    this.oldEmail = info.email;
                    if (info) {
                        this.form = {
                            id: info.id,
                            name: info.name,
                            userName: info.userName,
                            mobile: info.mobile,
                            idNo: info.idNo,
                            email: info.email,
                            emailCode: info.emailCode,
                            address: info.address,
                            bank: info.bank,
                            account: info.account,
                            idFrontImg: info.idFrontImgUrl,
                            idFrontImgPath: info.idFrontImg,
                            idBackImg: info.idBackImgUrl,
                            idBackImgPath: info.idBackImg,
                            idHandFrontImg: info.idHandFrontImgUrl,
                            idHandFrontImgPath: info.idHandFrontImg,
                            idHandBackImg: info.idHandBackImgUrl,
                            idHandBackImgPath: info.idHandBackImg,
                        }
                        if (info.idFrontImg) {
                            this.getImg(info.idFrontImg).then(res => {
                                this.form.idFrontImg = res;
                                this.$forceUpdate();
                            })
                        }
                        if (info.idBackImg) {
                            this.getImg(info.idBackImg).then(res => {
                                this.form.idBackImg = res;
                                this.$forceUpdate();
                            })
                        }
                        if (info.idHandFrontImg) {
                            this.getImg(info.idHandFrontImg).then(res => {
                                this.form.idHandFrontImg = res;
                                this.$forceUpdate();
                            })
                        }
                        if (info.idHandBackImg) {
                            this.getImg(info.idHandBackImg).then(res => {
                                this.form.idHandBackImg = res;
                                this.$forceUpdate();
                            })
                        }
                        // this.userId = info.id;
                        this.backupsform = JSON.stringify(this.form)
                    }
                }
            },
            async getImg(file) {
                let params = {
                    imagePath: file
                }
                const res = await writerImgApi(params);
                if (res.success) {
                    return res.data
                }
            },
            /*****上传图片*********/
            async uploadFun(e, code) {
                if (!this.token) {
                    // this.isshowlogin = true
                    // return false
                } else if (e.target.files.length == 0) {
                    this.$faild('custom', '请选择要上传的图片')
                    return false
                }
                let file = e.target.files[0];
                // this.form.iconTempFile = window.URL.createObjectURL(e.target.files[0]);
                // 上传图片地址
                this.uploadurl = `${baseURL.AHEAD}/writer/sign/inspect/upload/img`;
                let fileFormData = new FormData();
                fileFormData.append("img", file);
                fileFormData.append("type", this.uploadIndex);
                showLoading()
                const res = await this.uploadImgFun('post', this.uploadurl, fileFormData)
                if (res.success) {
                    hideLoading()
                    return res.data.imageUrl
                } else {
                    hideLoading()
                    this.$faild('operation')
                }
            },
            uploadFun1(e) {
                this.uploadIndex = 1
                this.uploadFun(e).then(res => {
                    console.log(res)
                    this.form.idFrontImg = res
                    this.$forceUpdate();
                })
            },
            uploadFun2(e) {
                this.uploadIndex = 2
                this.uploadFun(e).then(res => {
                    this.form.idBackImg = res
                    this.$forceUpdate();
                })
            },
            uploadFun3(e) {
                this.uploadIndex = 3
                this.uploadFun(e).then(res => {
                    this.form.idHandFrontImg = res
                    this.$forceUpdate();
                })
            },
            uploadFun4(e) {
                this.uploadIndex = 4
                this.uploadFun(e).then(res => {
                    this.form.idHandBackImg = res
                    this.$forceUpdate();
                })
            },
            //邮箱验证
            sendEmail() {
                if (!this.form.email) {
                    this.$faild('custom', '请输入正确的邮箱')
                    return false
                }
                let params = {
                    email: this.form.email
                }
                emailCheckApi(this.qs.stringify(params))
                    .then(res => {
                        if (res.success) {
                            this.$success('custom', '发送成功，请前往邮箱查看验证码')
                        }
                    })
                    .catch(() => {});

            },
            saveInfoFun(formName) {
                // console.log(this.form)
                let params = {
                    id: this.form.id,
                    bookId: this.$route.params.id,
                    name: this.form.name,
                    userName: this.form.userName,
                    idNo: this.form.idNo,
                    email: this.form.email,
                    // emailCode :this.form.emailCode,
                    address: this.form.address,
                    bank: this.form.bank,
                    account: this.form.account,
                    idFrontImg: this.form.idFrontImgPath,
                    idBackImg: this.form.idBackImgPath,
                    idHandFrontImg: this.form.idHandFrontImgPath,
                    idHandBackImg: this.form.idHandBackImgPath,
                }
                this.$refs[formName].validate(valid => {
                    // console.log(valid)
                    if (valid) {
                        writerEditApi(params)
                            .then(res => {
                                if (res.success) {
                                    this.$success('custom', '保存成功!')
                                    this.getNormalInfoFun()
                                }
                            })
                            .catch(() => {});
                    }
                })
            },
            /*开户行*/
            openbankInfo (flag) {
                this.bankVisible = true
                this.bankVisibleType =flag
                if (this.bankVisibleType==2) {
                    payloggetBank().then(res=>{
                        this.bankList = res.data;
                    })
                    this.getProvinceList()
                }
            },
            getProvinceList(val) {
                let params = {}
                if (val) {
                    params = {code: val}
                }
                paylogprovince(params).then(res=>{
                    if (val) {
                        this.cityList = res.data;
                        this.bankForm.city = ''
                    } else {
                        this.provinceList = res.data;
                    }
                })
            },
            provincekChange(e) {
                this.bankForm.provinceDesc = this.provinceList.filter(item=>{
                    return item.code == e
                })[0].text
                this.getProvinceList(e)
            },
            cancel () {
                // if (!this.form.bank) {
                //     this.bankForm={
                //         bank: '',
                //         provice:'',
                //         provinceDesc:'',
                //         city:'',
                //         name:'',
                //     }
                // }
                this.bankVisible = false

            },
            saveShelf () {
                this.$refs.bankForm.validate((valide)=>{
                    if (valide) {
                        let bank = `${this.bankForm.bank}${this.bankForm.provinceDesc}${this.bankForm.city}${this.bankForm.name}`
                        // this.cancel()
                        modifybankinfo({account:this.bankForm.account,bank:bank}).then(res=>{
                            if (res.code ==1) {
                                this.$success('custom', '重置成功')
                                this.bankVisible = false
                                this.getNormalInfoFun()
                            }

                        })

                    }

                })
            },
        },
        // beforeRouteLeave(to, from, next) {
        //     let $this = this;
        //     // console.log($this.backupsform)
        //     $this.backupsform = $this.backupsform ? JSON.parse($this.backupsform) : null
        //     if ($this.iskeep = true) {
        //         next();
        //     } else if (
        //         $this.backupsform && (
        //             $this.form.name == $this.backupsform.name &&
        //             $this.form.userName == $this.backupsform.userName &&
        //             $this.form.mobile == $this.backupsform.mobile &&
        //             $this.form.idNo == $this.backupsform.idNo &&
        //             $this.form.email == $this.backupsform.email &&
        //             $this.form.emailCode == $this.backupsform.emailCode &&
        //             $this.form.address == $this.backupsform.address &&
        //             $this.form.bank == $this.backupsform.bank &&
        //             $this.form.account == $this.backupsform.account &&
        //             $this.form.idFrontImg == $this.backupsform.idFrontImg &&
        //             $this.form.idBackImg == $this.backupsform.idBackImg &&
        //             $this.form.idHandFrontImg == $this.backupsform.idHandFrontImg &&
        //             $this.form.idHandBackImg == $this.backupsform.idHandBackImg
        //
        //         )
        //     ) {
        //         next()
        //     } else {
        //         let a = window.confirm("离开页面更改的内容将丢失！");
        //         if (a) {
        //             next();
        //         } else {
        //             next(false);
        //         }
        //     }
        // },
    };
</script>
<style lang="scss">
    .bank-dialog{
        .el-dialog{
            .el-dialog__body,.el-dialog__header{
                padding: 0!important;
            }
            .dialog-header{
                height: 66px;
                border-bottom: 1px solid #F3F3F3;
                line-height: 66px;
                font-size: 16px;
                color: #333;
            }
            .bank-reset{
                padding: 50px 40px 30px;
                .el-icon-warning{
                    color: #F68A01;
                    font-size: 20px;
                }
                .bank-reset-title{
                    font-size: 18px;
                    color: #333;
                    font-weight: 500;
                }
                .bank-reset-con{
                    font-size: 16px;
                    line-height: 30px;
                    color: #333;
                    margin-top: 15px;
                }
                .reset-btn{
                    margin-top: 10px;
                    background: #F44944!important;
                    color: #fff;
                    border: none;
                    margin-left: 40px;
                }
                /deep/.reset-cancel-btn{
                    margin-top: 10px;
                    color: #999999!important;
                }
            }
            .bankForm{
                padding: 0 30px 30px;
                .el-form-item__label{
                    float: none;
                    font-size: 16px;
                    color: #333;
                }
                /deep/.el-input__inner,
                /deep/.el-textarea__inner{
                    background-color: #F5F5F5!important;
                    border: 1px solid #ddd!important;
                }

            }
            .cityInput{
                margin-top: 40px;
                .el-form-item__label{
                    display: none;
                }
            }
        }

    }
    .bank-btn{
        width: 140px;
        height: 40px;
        padding: 0;
        line-height: 40px;
        font-size: 18px;
        margin-top: 79px;
        &.el-button--warning{
            background: #F68A01!important;
            color: #fff!important;
            margin-left: 134px;
        }
        &.el-button--primary{
            width: 110px;
        }

    }

</style>
<style lang="scss" scoped>
    @import "@/styles/author.scss";

    .contract-form {
        // padding-top: 35px;
        padding-top: 40px 0;

        // margin: 0 50px;
        .sfz-tips {
            position: relative;

            .tip-text {
                position: absolute;
                top: -36px;
                left: 150px;
                cursor: pointer;
                color: #A7A7A7;
                background: url('../../assets/author/ic_tip.png') no-repeat right;
                background-size: 14px 14px;
                padding-right: 20px;

                .tip-imgs {
                    position: absolute;
                    // top: -30px;
                    left: 50px;
                    display: none;
                    width: 772px;
                    height: 311px;
                    background: #FFFFFF;
                    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.1);
                    padding: 0 45px;
                    box-sizing: border-box;
                    z-index: 9;

                    &>div {
                        height: 100%;
                    }

                    img {
                        display: inline-block;
                        width: 331px;
                        height: 191px;
                    }
                }
            }

            .tip-text:hover {
                color: #F68A01 !important;
                background: url('../../assets/author/ic_tip1.png') no-repeat right;
                background-size: 14px 14px;

                .tip-imgs {
                    display: block;
                }
            }
        }

        .avatar-uploader {
            width: 331px;
            height: 191px;
        }

        .avatar-uploader {
            position: relative;
            background: #F5F5F5;
            border-radius: 4px;
            margin-right: 20px;

            .el-upload {
                width: 331px;
                height: 191px;

                .jia-btn {
                    width: 65px;
                    height: 65px;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    margin-left: -32px;
                    margin-top: -32px;
                }

                .sfz-img {
                    width: 100%;
                    height: 100%
                }
            }
        }

        .avatar-uploader .el-upload-input {
            width: 331px;
            height: 191px;
        }
    }
    .bank-input{
        height: 40px;
        line-height: 40px;
        background: #F5F5F5;
    }
    .author-info-form {
        padding-top: 35px;
        margin: 0 50px;
        padding-bottom: 30px;

        .avatar-uploader {
            width: 210px !important;
            height: 160px !important;
            position: relative;
        }

        .avatar-uploader .el-upload {
            width: 210px !important;
            height: 160px !important;

            img {
                width: 210px !important;
                height: 160px !important;
            }
        }

        .avatar-uploader .el-upload-input {
            width: 210px !important;
            height: 160px !important;
        }
    }

    .sms-btn {
        position: absolute;
        top: 3px;
        left: 575px;
        color: #F68A01;
        cursor: pointer;
    }
</style>
